/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import Button, { ButtonProps } from '../Button'

const linkCss = css`
  font-size: 16px;
  letter-spacing: 0.5px;
  line-height: 20px;
  font-family: Roboto;
  text-decoration: underline;
  padding: 6px 6px;
  text-transform: none;

  &:hover {
    background-color: transparent;
  }
`

const LinkButton = (props: ButtonProps) => <Button css={linkCss} {...props} />

export default LinkButton
